import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';
import { weakKey } from '../../../../utilities/weakKey';
import { unitCardSectionConfig } from '../../UnitCardConfig';
import { UnitCardTypes } from '../../UnitCardTypes';
import { Icon } from '../../../../utilities/icomoon-css';
import { PromoPlanModal } from './PromoPlanComponent';
import { useSectionData } from '../../../../sections/rentalPage/components/dynamicForm/hooks/dataContext';

export const RatesComponent = ({
  unitCardsConfig,
  isAccordian,
  theme,
  iconsList,
  rentalinfoRes,
}: UnitCardTypes.TRates) => {
  const {
    promoPlans,
    globalContext: { selectedPromoPlanId, setSelectedPromoPlanId },
  } = useSectionData();
  const { ratesTitle, sumTitle, promoPlanTitle } = unitCardsConfig.ratesDetails;
  const [showModal, setShowModal] = useState(false);
  const [rentalPromoPlanCharge, setRentalPromoPlanCharge] = useState('');
  const [selectedPromoPlanTitle, setSelectedPromoPlanTitle] = useState('');
  const isMoveInFlow = location.pathname.includes('move-in');

  useEffect(() => {
    if (isMoveInFlow) {
      const indexedObject: any = {};
      promoPlans?.data?.forEach((eachPlan: any) => {
        const { id } = eachPlan || {};
        indexedObject[id] = eachPlan;
      });
      const optedPromoPlanTitle =
        indexedObject[selectedPromoPlanId]?.value?.title;
      setSelectedPromoPlanTitle(optedPromoPlanTitle);

      const rentalCharges = rentalinfoRes?.charges?.data;
      const promoPlanCharges =
        rentalCharges?.length &&
        rentalCharges.filter((charge: any) =>
          charge.description.includes(optedPromoPlanTitle)
        );
      setRentalPromoPlanCharge(promoPlanCharges[0]);
    }
  }, []);

  const themeConfig = {
    textColor: 'primary',
    sectionBackgroundColor: 'secondary',
  };
  if (theme === 'dark') {
    themeConfig.textColor = 'secondary';
    themeConfig.sectionBackgroundColor = 'primary';
  }
  const [ratesactive, setRatesActive] = useState<boolean>(true);

  const toggleAccordion = () => {
    return setRatesActive(!ratesactive);
  };
  const getIcon = () => {
    const { iconOne, iconTwo } = iconsList;
    return ratesactive ? iconTwo.name : iconOne.name;
  };

  const renderAppliedPromoPlanSection = (charge: any, title: string) => {
    const handleRemovePromoPlan = () => {
      !isAccordian && setSelectedPromoPlanId('');
    };

    return (
      <div className="appliedPromoContainer">
        <p>{unitCardsConfig.promoPlans.promoPlansApplied}</p>
        <div className="promoDiscountWrapper">
          <div className="promoDiscountLabel">
            <div className="promoTitle">{title}</div>
            <div
              className={
                !isAccordian ? 'promoCloseIcon' : 'promoCloseIconDisabled'
              }
              onClick={handleRemovePromoPlan}
            >
              X
            </div>
          </div>
          <span className="promoRateValue has-text-text">
            {unitCardSectionConfig.currencyCode} {charge.amount}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="applicableRates">
      <p
        className={`applicableRatesHeading has-text-text ${isAccordian &&
          'is-hidden-mobile'} subtitle1`}
      >
        {ratesTitle}
      </p>
      <>
        {isAccordian && (
          <div className="is-hidden-tablet">
            <button
              type="button"
              className={`accordionHeadingSection is-flex flex-direction-row is-justify-content-space-between has-background-${themeConfig.sectionBackgroundColor} ${theme}`}
              onClick={() => toggleAccordion()}
            >
              <h5
                className={`accordianHeader has-text-weight-bold has-text-${themeConfig.textColor}`}
              >
                {ratesTitle}
              </h5>
              <FontAwesomeIcon
                iconClassName={getIcon()}
                iconContextProps={{
                  className: `has-text-${themeConfig.textColor}`,
                }}
              />
            </button>
          </div>
        )}
        {ratesactive && Object.keys(rentalinfoRes).length > 0 ? (
          <div className="ratesContainer">
            {rentalinfoRes.rental_info?.reservation_deposit !== 0 &&
              rentalinfoRes.charges.data.length === 0 && (
                <p className="is-flex is-justify-content-space-between pb-2 pt-2 has-text-text">
                  <span className="rateLabel has-text-text">
                    {unitCardsConfig.ratesDetails.reservationTitle}
                  </span>
                  <span className="rateValue has-text-text reservationDepositText">
                    {unitCardSectionConfig.currencyCode}{' '}
                    {rentalinfoRes.rental_info?.reservation_deposit}
                  </span>
                </p>
              )}
            {rentalinfoRes &&
              rentalinfoRes.charges &&
              rentalinfoRes.charges.data?.map((item: any) => {
                let isPromoPlanCharge = false;
                if (selectedPromoPlanId) {
                  isPromoPlanCharge = item?.description.includes(
                    selectedPromoPlanTitle
                  );
                }
                return (
                  <>
                    {!isPromoPlanCharge ? (
                      <p
                        className="is-flex is-justify-content-space-between pb-2 pt-2 has-text-text"
                        key={weakKey(item)}
                      >
                        <span className="rateLabel has-text-text">
                          {item.description}
                        </span>
                        <span className="rateValue has-text-text">
                          {unitCardSectionConfig.currencyCode} {item.amount}
                        </span>
                      </p>
                    ) : null}
                  </>
                );
              })}
            {isMoveInFlow ? <hr className="horizontalTag"></hr> : null}
            {isMoveInFlow &&
              (!selectedPromoPlanId ? (
                <p
                  className="promotionalPlansLabel is-flex is-justify-content-space-between is-align-items-center pb-2 pt-2 has-text-text"
                  onClick={() => !isAccordian && setShowModal(true)}
                >
                  <span className="promoPlanLabel">{promoPlanTitle}</span>
                  <Icon
                    name="tfw-arrow-right-2-cp"
                    size={12}
                    title="tfw-arrow-right-2-cp"
                  />
                </p>
              ) : (
                renderAppliedPromoPlanSection(
                  rentalPromoPlanCharge,
                  selectedPromoPlanTitle
                )
              ))}
            {showModal ? (
              <PromoPlanModal
                showModal={showModal}
                setShowModal={setShowModal}
              />
            ) : null}
            <hr className="horizontalTag"></hr>
            <p className="is-flex is-justify-content-space-between pb-2 pt-2 has-text-text">
              <span className="rateLabel">{sumTitle}</span>
              <span className="rateValue">
                {unitCardSectionConfig.currencyCode}{' '}
                {rentalinfoRes.charges.total_amount || ''}
              </span>
            </p>
            <hr className="horizontalTag" />
          </div>
        ) : (
          <></>
        )}
      </>
    </div>
  );
};
